<template>
  <div>
    <div class="checkbox-wrapper modal-register-conditions">
      <div class="checkbox">
        <input name="согласие" type="checkbox" v-model="model" id="offer-conditions"/>
        <label for="offer-conditions">
          Я согласен(на) с условиями <a @click="onOfferLinkClick" target="_blank" href="https://exporteduru.servicecdn.ru/media/default/0003/48/6466dc3ff5044fe7c404fd9d0f7cffaf5757ab1e.pdf">оферты</a>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import vmMixin from "@/mixins/vmMixin";

export default {
  name: "EventOfferCondition",
  mixins: [vmMixin],
  methods: {
    onOfferLinkClick(e) {
      e.stopPropagation();
      e.preventDefault();
      window.open(e.target.href, '_blank');
    }
  }
}
</script>

<style scoped>
.checkbox-wrapper label {
  width: 100%!important;
  margin: 0 2.4rem 2.4rem;
}

.checkbox-wrapper label a {
  position: relative;
  z-index: 2;
}
</style>